import React from 'react';
import { PropTypes } from 'prop-types';
import classNames from 'classnames';
import HrbTranslate from '../language/HrbTranslate';
import './Buttons.scss';


const ActionButton = (props) => {
    var buttonClass = "button is-primary radius-small"
    if (props.buttonClass) {
        buttonClass = props.buttonClass + ' ' + buttonClass
    }
    if (props.inProgress) {
        buttonClass += " is-loading";
    }
    return (
        <div className={classNames('action-button', { 'disabled': props.isDisabled === true })}>
            <button type="button" className={buttonClass} onClick={props.complete ? () => { } : props.onClick} disabled={props.isDisabled}>
                {props.complete && 
                    <i className='la la-check' />
                }
                {!props.complete &&
                    <HrbTranslate text={props.text} params={props.params} />
                }
                {props.children}
            </button>
        </div>
    );
}

ActionButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
    isDisabled: PropTypes.bool,
    params: PropTypes.object,
    buttonClass: PropTypes.string,
    inProgress: PropTypes.bool,
    complete: PropTypes.bool
};

export default ActionButton;